import { NavLink, useNavigate } from "react-router-dom";
import "./dashboard.scss";
import { faBackward } from "@fortawesome/free-solid-svg-icons";

interface DashboardProps {
  children: any;
  pageTitle?: string;
  subChildren?: any;
}

export default function Dashboard({
  children,
  pageTitle,
  subChildren,
}: DashboardProps) {
  return (
    <div className="dashboard">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>Admin Portal</h2>
        </div>
        <nav className="sidebar-nav">
          <ul>
            <li>
              <NavLink
                to="/dashboard"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Overview
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/students"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Students
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/teachers/dashboard"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Teachers
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/partners/dashboard"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Partners
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/review?status=PENDING"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Pending Review
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/report/list"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Reports
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/email/compose"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Email Composer
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/admin/dashboard"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Admin
              </NavLink>
            </li>
            <li>
              <a href="#">Settings</a>
            </li>

            <li>
              <NavLink
                to="/payout/dashboard"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Payout
              </NavLink>
            </li>

            <li>
              <a href="/logout">Logout</a>
            </li>
          </ul>
        </nav>
      </aside>

      <div className="main-content">
        {pageTitle ? (
          <header className="dashboard-header">
            <h2>{pageTitle}</h2>
          </header>
        ) : null}

        <section className="dashboard-content">{children}</section>

        {subChildren && <>{subChildren}</>}
      </div>
    </div>
  );
}
